<!--suppress ALL -->
<script lang="ts">
import {statusSantries} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class StatusSantriSelect extends Vue {

    @Prop({default: statusSantries[0], type: String})
    public status: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({type: String, default: null})
    public type: any;

    @Prop({type: String, default: null})
    public message: any;

    @Prop({type: Boolean, default: false})
    public disabled: any;

    public onSelectProses(param: any) {
      this.$emit('update:status', param || statusSantries[0]);
      this.$emit('selected', param);
    }

    public render(createElement: Function) {
      const {$t, status, isFullwidth, message, type} = this;

      const mainAttr: any = {
        props: {
          value: status,
          isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.status_santri')}`
        },
        attrs: {disabled: this.disabled},
        on: {change: this.onSelectProses}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(statusSantries).map((item: any) => {
        const option: any = {attrs: {value: item}};

        return createElement('option', option, item.toUpperCase());
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label: $t('label.status_santri'), message, type}}, [main]);
    }
  }
</script>
